<iframe
  [src]="iframeUrl"
  width="100%"
  style="border: 0; overflow: hidden"
  class="b-and-o-iframe"
></iframe>
